module.exports = __webpack_public_path__ + "img/visa.60a6129.svg";